import { ADD_APPLICATION as addApplication } from './addApplication';
import { DEFAULT_APPLICATIONS as defaultApplications } from './default';
import { VIEW_APPLICATION as viewApplication } from './viewApplication';

export const APPLICATIONS = {
  addApplication,
  defaultApplications,
  viewApplication
};
